import { PortalConfig } from 'src/context';

export interface LabelsForI18n {
  client_other: string;
  client_one: string;
  company_other: string;
  company_one: string;
}

export const getCustomizedLabels = ({
  customLabels: configLabels,
}: {
  customLabels: PortalConfig['features']['customLabels'] | null;
}): LabelsForI18n => {
  // Default labels if clientTerm/companyTerm are not set
  let customLabels: LabelsForI18n = {
    client_one: 'Client',
    client_other: 'Clients',
    company_one: 'Company',
    company_other: 'Companies',
  };

  if (!configLabels) {
    return customLabels;
  }

  // Override client labels if clientTerm is set
  // or use the custom labels from the portal config if clientTerm is "Other"
  switch (configLabels?.clientTerm) {
    case 'Contact':
      customLabels = {
        ...customLabels,
        client_one: 'Contact',
        client_other: 'Contacts',
      };
      break;
    case 'Person':
      customLabels = {
        ...customLabels,
        client_one: 'Person',
        client_other: 'People',
      };
      break;
    case 'User':
      customLabels = {
        ...customLabels,
        client_one: 'User',
        client_other: 'Users',
      };
      break;
    case 'Other':
      customLabels = {
        ...customLabels,
        client_one: configLabels.clientOne ?? customLabels.client_one,
        client_other: configLabels.clientMany ?? customLabels.client_other,
      };
      break;
  }

  // Override company labels if companyTerm is set
  // or use the custom labels from the portal config if companyTerm is "Other"
  switch (configLabels?.companyTerm) {
    case 'Family':
      customLabels = {
        ...customLabels,
        company_one: 'Family',
        company_other: 'Families',
      };
      break;
    case 'Group':
      customLabels = {
        ...customLabels,
        company_one: 'Group',
        company_other: 'Groups',
      };
      break;
    case 'Space':
      customLabels = {
        ...customLabels,
        company_one: 'Space',
        company_other: 'Spaces',
      };
      break;
    case 'Other':
      customLabels = {
        ...customLabels,
        company_one: configLabels.companyOne ?? customLabels.company_one,
        company_other: configLabels.companyMany ?? customLabels.company_other,
      };
      break;
  }

  return customLabels;
};
